<div class="profile-container">
    <div class="">
        <div class="profile-content">  
            <div class="personal-details">
                <h4 class="personal-details-title">DELETE PRIVILEGE</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Seq No</th>
                      <th scope="col">Group Name</th>
                      <th scope="col">Screen List</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let privilege of privilege | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: page,
                        totalItems: count
                      }  ;let i = index">
                      <th scope="col">{{privilege.seqNo}}</th>
                      <th scope="col">{{privilege.groupName}}</th>
                      <th scope="col">{{privilege.screenPrivilegeList.length}}</th>
                      <th scope="col">
                          <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 10px;margin-right: 10px" (click)="del(privilege.id)" data-toggle="modal" data-target="#deleteModal"    width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                          </svg> 
                       </th>
                    </tr>
                  </tbody>
                </table>
                <div class="pagination-block" *ngIf="privilege.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                </div>
            </div>
  
        </div>
    </div>
  </div>

  <div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLabel">Conformation!!
            <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </span>
          </h5>
        </div>
        <div class="modal-body">
          <p>are you sure? want to delete??</p>   
        <div class="modal-footer">
          <button type="button" id="closeModalButton1"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="deletePriviilege()">Delete</button>
        </div>
      </div>
    </div>
  </div>
</div>
